import React from 'react';
import { Section } from './Section';
export function Gallery() {
  return <Section data-id="element-84">
      <div className="mb-16 text-center max-w-2xl mx-auto" data-id="element-85">
        <p className="text-sm font-medium text-[#FF6B1A] tracking-widest uppercase mb-4" data-id="element-86">
          Mirá el detalle
        </p>
        <h2 className="text-3xl md:text-5xl font-light tracking-tight text-balance" data-id="element-87">
          Calidad <span className="text-[#FF6B1A] font-semibold" data-id="element-88">premium</span>{' '}
          en cada detalle
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-89">
        {/* Feature image - battery indicator + flexible hose */}
        <div className="rounded-3xl overflow-hidden bg-[#FF6B1A] aspect-square md:aspect-auto" data-id="element-90">
          <img src="https://cdn.magicpatterns.com/uploads/bBQBC4WR9JHGAHKWQc972o/567537fb-5394-4fc6-96ac-2182a2f0346c.png" alt="Indicador de batería y manguera flexible" className="w-full h-full object-cover" data-id="element-91" />
        </div>

        {/* Dimensions image */}
        <div className="rounded-3xl overflow-hidden bg-white border border-black/5 aspect-square md:aspect-auto" data-id="element-92">
          <img src="https://cdn.magicpatterns.com/uploads/ofsjkYp2Fz9TmAMgBxoWYs/ChatGPT_Image_5_may_2026,_19_53_22.png" alt="Dimensiones del producto: 250mm x 160mm x 30mm, peso 166g" className="w-full h-full object-contain" data-id="element-93" />
        </div>
      </div>

      {/* Specs strip */}
      <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-px bg-black/5 rounded-2xl overflow-hidden border border-black/5" data-id="element-94">
        <div className="bg-white p-6 md:p-8" data-id="element-95">
          <div className="text-xs text-[#6B6B6B] uppercase tracking-wider mb-2" data-id="element-96">
            Peso
          </div>
          <div className="text-2xl md:text-3xl font-light" data-id="element-97">
            165<span className="text-base text-[#6B6B6B] ml-1" data-id="element-98">g</span>
          </div>
        </div>
        <div className="bg-white p-6 md:p-8" data-id="element-99">
          <div className="text-xs text-[#6B6B6B] uppercase tracking-wider mb-2" data-id="element-100">
            Dimensiones
          </div>
          <div className="text-2xl md:text-3xl font-light" data-id="element-101">
            250<span className="text-base text-[#6B6B6B] ml-1" data-id="element-102">mm</span>
          </div>
        </div>
        <div className="bg-white p-6 md:p-8" data-id="element-103">
          <div className="text-xs text-[#6B6B6B] uppercase tracking-wider mb-2" data-id="element-104">
            Batería
          </div>
          <div className="text-2xl md:text-3xl font-light" data-id="element-105">
            20<span className="text-base text-[#6B6B6B] ml-1" data-id="element-106">hs</span>
          </div>
        </div>
        <div className="bg-white p-6 md:p-8" data-id="element-107">
          <div className="text-xs text-[#6B6B6B] uppercase tracking-wider mb-2" data-id="element-108">
            Color
          </div>
          <div className="text-2xl md:text-3xl font-light" data-id="element-109">Negro</div>
        </div>
      </div>
    </Section>;
}